import FileUploadIcon from './FileUploadIcon';
export default FileUploadIcon;
